<template>
  <div>
    <head-info
      :nav="item.nav"
      :banner="item.banner"
    />
    <film-item :list="item.filmList" />
    <hot-update-item :list="item.hotUpdate" />
    <hot-video-item :list="item.hotVideo" />
    <gotop />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Gotop from '../common/components/Gotop';
import { getSsrUigsParams } from '../common/js/util';
import FilmItem from './components/FilmItem';
import HeadInfo from './components/HeadInfo';
import HotUpdateItem from './components/HotUpdateItem';
import HotVideoItem from './components/HotVideoItem';

export default {
  components: {
    HeadInfo,
    Gotop,
    FilmItem,
    HotVideoItem,
    HotUpdateItem,
  },
  computed: {
    ...mapState('home', ['itemData']),
    item() {
      return this.itemData;
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('home/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_HOME_ERROR]', err));
  },
  mounted() {
    // 日志上报
    const self = this;
    const params = getSsrUigsParams();
    window.UIGS_PARA = params;
    self.$uigs.send(params);
  },
};
</script>
